import axios from "axios";
import { storage } from "../../utils/storage";

const TOKEN_ENDPOINT = process.env.REACT_APP_API_TOKEN_ENDDPOINT; //"https://efficiency-agility-7802--bisleriqa.sandbox.my.salesforce.com/services/oauth2/token";
const BASE_URL = process.env.REACT_APP_API_BASE_URL; //"https://efficiency-agility-7802--bisleriqa.sandbox.my.salesforce.com/";

//const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
//const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
//const USERNAME = process.env.REACT_APP_SF_UN;
//const PASSWORD = process.env.REACT_APP_SF_PASS;
const APP_TYPE = process.env.REACT_APP_TYPE;
const ENVIRONMENT = process.env.REACT_APP_APP;

console.log("process.env.BASE_URL ", BASE_URL);

let tokenRetrievalAttempts = 0;
const maxTokenRetrievalAttempts = 3;

const refreshAccessToken = async () => {
  try {
    console.log("Token endpoint:", TOKEN_ENDPOINT);
    console.log("Request payload:", { type: APP_TYPE, app: ENVIRONMENT });
    console.log("APP_TYPE value:", APP_TYPE);
    console.log("ENVIRONMENT value:", ENVIRONMENT);

    const response = await axios.post(
      TOKEN_ENDPOINT,
      { type: APP_TYPE, app: ENVIRONMENT },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    console.log("SFDC token response: ", response);
    if (response && response.data && response.data.access_token) {
      console.log("setting acces token");
      console.log("--- response.data.access_token", response.data.access_token);
      storage.setItem("access_token", response.data.access_token);
      return response.data.access_token; // Resolve the promise with the new token
    }
  } catch (error) {
    console.error("Error refreshing access token:", error);

    // Increment the attempts counter
    tokenRetrievalAttempts++;

    // Check if the maximum number of attempts is reached
    if (tokenRetrievalAttempts < maxTokenRetrievalAttempts) {
      // Wait for a delay and then retry
      await new Promise((resolve) => setTimeout(resolve, 500));
      return refreshAccessToken(); // Recursively call the function to retry
    } else {
      console.error("Maximum token retrieval attempts reached");
      throw new Error("Failed to refresh access token after maximum attempts");
    }
  }
};

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  async (config) => {
    console.log("--- request interceptor", config);
    const token = storage.getItem("access_token");
    const accessToken = token ? token : "";
    console.log("--- token value from storage", accessToken);
    config.headers["Authorization"] = `Bearer ${accessToken}`;
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  },
);

// Add a response interceptor to handle 401 unauthorized responses
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log("response interceptor ---", error);

    if (
      error.response === undefined ||
      (error.response && error.response.status === 401)
    ) {
      console.log("--- inside request interceptors");
      // If the response status is 401, attempt to refresh the access token
      try {
        storage.removeItem("access_token");
        await refreshAccessToken();
        // Retry the original request after obtaining a new access token
        console.log("--- after new token update");
        const originalRequestConfig = error.config;
        // Modify the headers with the new token
        const accessToken = storage.getItem("access_token");
        console.log("new token ---", accessToken);
        originalRequestConfig.headers["Authorization"] =
          "Bearer " + accessToken;

        console.log("Original Request Config:", originalRequestConfig);

        return api(originalRequestConfig);
      } catch (refreshError) {
        // Handle the error from the refresh attempt
        console.error("Error refreshing access token:", refreshError);
        // Redirect to the login screen or handle the error as needed
        throw refreshError;
      }
    }
    // For other errors, just pass them through
    throw error;
  },
);

export const createcollector = async (collector) => {
  console.log("requesor --- ", collector);
  try {
    const response = await api.post(
      `/services/apexrest/collector_register/`,
      collector,
    );
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const updateCaseData = async (caseData, sfId, handleSuccess) => {
  console.log("HITTING THE CHECKOUT API");
  try {
    const response = await api.put(
      `/services/apexrest/collector_checkIn_checkout/${sfId}`,
      caseData,
    );
    handleSuccess(response);
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const newVolunteer = async (Volunteer, sfId, handleSuccess) => {
  console.log("Volunteer --- ", Volunteer);
  try {
    const response = await api.post(
      `/services/apexrest/new_volunteer/${sfId}`,
      Volunteer,
    );
    handleSuccess(response);
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const postCollectorDocument = async (sfId, docData) => {
  console.log("HITTING THE POST DOC API");
  try {
    const response = await api.post(
      `/services/apexrest/upload_collector_documents/${sfId}`,
      docData,
    );
    debugger;
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const getCollectorDocument = async (sfId) => {
  console.log("sfId--------->", sfId);
  console.log("HITTING THE GET DOC API");
  try {
    const response = await api.get(
      `/services/apexrest/get_collector_documents/${sfId}`,
    );

    console.log("Raw API Response:", response);
    console.log("Response Data:", response.data);

    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const getCollectorsDashboardData = async (sfId) => {
  console.log("HITTING THE COLLECTOR DASHBOARD API");
  try {
    const response = await api.get(
      `/services/apexrest/final_dashboard_collector/${sfId}`,
    );
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const getVolunteers = async (sfId) => {
  console.log("HITITNG THE MY RESOURCE API");
  try {
    const response = await api.get(`/services/apexrest/get_volunteers/${sfId}`);
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const getFeedback = async (sfId) => {
  try {
    const response = await api.get(
      `/services/apexrest/collectore_feedback/${sfId}`,
    );
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const getCollectorMyTicketData = async (sfId, offset) => {
  console.log("HITTING THE MY TICKET API");
  try {
    const response = await api.get(
      `/services/apexrest/collector_tickets/${sfId}?offset=${offset}`,
    );
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};
export const getCollectorNotifications = async (sfId) => {
  console.log("HITTING THE NOTIFICATION API");
  try {
    const response = await api.get(
      `/services/apexrest/collector_notification/${sfId}`,
    );
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const getUserInfo = async (sfId) => {
  console.log("HITTING THE USER INFO PROFILE API");
  try {
    const response = await api.get(`/services/apexrest/get_user_info/${sfId}`);
    return response.data;
  } catch (e) {
    console.log("Error: " + e);
  }
};

export const getDashboardDataColl = async (
  sfId,
  duration,
  startDate,
  endDate,
) => {
  console.log("API Start Date", startDate);
  console.log("API End Date", endDate);

  try {
    console.log("Calling getDashboard API", sfId);

    if (startDate && endDate) {
      const response = await api.get(
        `/services/apexrest/final_dashboard_collector/${sfId}?type=${duration}&start_date=${startDate}&end_date=${endDate}`,
      );
      return response.data;
    } else {
      const response = await api.get(
        `/services/apexrest/final_dashboard_collector/${sfId}?type=${duration}`,
      );
      return response.data;
    }
  } catch (e) {
    console.log("Status:", e.response?.status);

    console.log("Salesforce Error:", e.response?.data);

    throw e;
  }
};

export const getCollectorDashboardViewDet = async (
  sfId,
  duration,
  filter,
  startDate,
  endDate,
  offset,
) => {
  try {
    console.log("Calling getCollectorDashboardViewDet API", sfId);

    if (startDate && endDate) {
      const response = await api.get(
        `/services/apexrest/collector_dashboard_viewdetails/${sfId}?type=${duration}&start_date=${startDate}&end_date=${endDate}&filter=${filter}&offset=${offset}`,
      );

      return response.data;
    } else {
      const response = await api.get(
        `/services/apexrest/collector_dashboard_viewdetails/${sfId}?type=${duration}&filter=${filter}&offset=${offset}`,
      );
      return response.data;
    }
  } catch (e) {
    console.error("Get Dashboard View Details Data API Error: ", e);
    throw e;
  }
};
